import { FieldValues, Path, TextFieldElement } from "react-hook-form-mui"

interface IProps<T extends FieldValues> {
  name: Path<T>
  required?: boolean
}
interface IField {
  url: string
}

export function Url<T extends FieldValues = IField>({
  required,
  name,
}: IProps<T>): JSX.Element {
  return (
    <TextFieldElement<T>
      name={name}
      label="Ссылка"
      required={required}
      fullWidth
    />
  )
}
